import React, { Component } from 'react';

export default class LogoMarquee extends Component {
  render() {
    // Array of placeholder logos - in a real project, you would replace these with actual logos
    const logos = [
      { id: 1, alt: "Company 1",img:"https://cdn.prod.website-files.com/662bb54b07234a7982d35055/66fd092a2efa2ddc4e5ddbb3_whats-on-dubai-logo.png" },
      { id: 2, alt: "Company 2",img:"https://cdn.prod.website-files.com/662bb54b07234a7982d35055/66fe2f455d62e90ce0bfcf6f_forbes-logo.png" },
      { id: 3, alt: "Company 3",img:"https://cdn.prod.website-files.com/662bb54b07234a7982d35055/66fe30c9157040ae42933b83_arn-logo.jpg" },
      { id: 4, alt: "Company 4" ,img:"https://cdn.prod.website-files.com/662bb54b07234a7982d35055/66fd09368368ea8a3d435edd_cnn-logo.png"},
      { id: 5, alt: "Company 5",img:"https://cdn.prod.website-files.com/662bb54b07234a7982d35055/66fd092a2efa2ddc4e5ddbb3_whats-on-dubai-logo.png" },
      { id: 6, alt: "Company 6",img:"https://cdn.prod.website-files.com/662bb54b07234a7982d35055/66fe2f455d62e90ce0bfcf6f_forbes-logo.png" },
      { id: 7, alt: "Company 7",img:"https://cdn.prod.website-files.com/662bb54b07234a7982d35055/66fe30c9157040ae42933b83_arn-logo.jpg" },
      { id: 8, alt: "Company 8" ,img:"https://cdn.prod.website-files.com/662bb54b07234a7982d35055/66fd09368368ea8a3d435edd_cnn-logo.png"},
    ]

    return (
      <section className="logo-marquee-section">
        <div className="container">
          {/* <h2 className="section-title">Our Partners</h2> */}

          <div className="marquee-container">
            {/* Marquee wrapper */}
            <div className="marquee-wrapper">
              {/* First set of logos */}
              <div className="marquee">
                {logos.map((logo) => (
                  <div key={logo.id} className="logo-item">
                    <img src={logo.img} alt={logo.alt} className="logo-image" />
                  </div>
                ))}
              </div>

              {/* Duplicate set of logos for seamless looping */}
              <div className="marquee">
                {logos.map((logo) => (
                  <div key={`duplicate-${logo.id}`} className="logo-item">
                    <img src={logo.img} alt={logo.alt} className="logo-image" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}
